<template>
    <div class="resource-list">
        <div :class="{resource:true, active:activeIndex===index}" v-for="(item,index) in actions" :key="index" @click="chooseResource(item,index)">
            <i :class="getIcon(item.element)"></i>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ResourceList",
        data(){
			return {
				activeIndex:-1
            }
        },
        computed:{
			actions(){
				return this.$store.state.actions||[]
            },
			elements(){
				return this.$store.state.elements||[]
			}
        },
        methods:{
			getIcon(element){
                const elm = this.elements.find(item=>item.name === element)
				if(!elm) return ""

                if(elm.type === "image"){
                    return "el-icon-picture"
                }else if(elm.type === "video"){
					return "icon-cam"
				}else if(elm.type === "gif"){
					return "el-icon-picture-outline"
				}else if(elm.type === "text"){
					return "icon-text"
				}else if(elm.type === "color"){
					return "el-icon-star-on"
				}else if(elm.type === "background"){
					return "el-icon-news"
				}else if(elm.type === "audio"){
					return "el-icon-bell"
				}
            },
			chooseResource(data, index){
				this.activeIndex = index
                this.$store.commit('update', {
                	activeAction: data
                })
                this.$nextTick(()=>{
					this.$store.dispatch('videoTemplate/updateElements')
					const elm =  this.elements.find(i=>i.name === data.element)
                    if(elm && (elm.type === 'image'|| elm.type === 'text'|| elm.type === 'video')){
						this.$nextTick(()=>{
							this.$store.dispatch('elm_select', {
								id: data.element + '_'+  data.name
							})
						})
                    }else{
						this.$store.dispatch('elm_unselect')
                        //todo
                        this.$store.commit('update', {
                        	selected:{
                                ...elm,
                                position:{}
                            }
                        })
                    }
                })
            }
        }
	}
</script>

<style scoped lang="scss">
    .resource-list{
        height:60px;
        background: #EFEFEF;
        padding:10px 20px 10px 50px;
        box-sizing: border-box;
        >.resource{
            display: inline-block;
            cursor:pointer;
            border:2px solid #FFF;
            width:40px;
            height:40px;
            background: #FFF;
            margin-right:5px;
            border-radius:2px;
            text-align: center;
            box-sizing: border-box;
            &.active{
                border-color:#41b883;
            }
            >i{
                font-size:20px;
                line-height:40px;
            }
        }
    }
</style>
